import React, { useRef, useState } from 'react'
import { Drawer, notification, Input, DatePicker, Row, Col } from 'antd'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { DefaultTablePagination, displayDate, InputBox } from '../../../components/_utils/appUtils'
import { addMeetingXTravelFxn, getAllMeetings } from '../actions'
import { TableComp } from 'sz-react-utils-lite'
import { ColumnWidth } from '../../WebComponent/columnWidth'
import { CountryCodeWithFlag } from '../../../components/_utils/countryUtil'

const { TextArea } = Input

const initialMeetingState = {
  meetingId: '',
  personName: '',
  contact: '',
  email: '',
  designation: '',
  companyName: '',
  companyWebsite: '',
  details: '',
  date: null,
  address: '',
  countryId: ''
}

const AddMeetingXTravelDrawer = (props) => {
  const [meetingState, setMeetingState] = useState(initialMeetingState)
  const dispatch = useDispatch()
  const tableRef = useRef()
  const { visible, onClose, onSubmit, eventId } = props

  const updateMeetingState = (data) => {
    setMeetingState((prevState) => ({
      ...prevState,
      ...data
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!meetingState.personName) {
      return notification.warning({ message: 'Please enter person name' })
    }
    if (!meetingState.contact) {
      return notification.warning({ message: 'Please enter contact number' })
    }
    if (!meetingState.email) {
      return notification.warning({ message: 'Please enter email address' })
    }
    if (!meetingState.date) {
      return notification.warning({ message: 'Please choose meeting date' })
    }


    if (eventId) {
      meetingState.eventId = eventId
    }

    const resp = await dispatch(addMeetingXTravelFxn(meetingState))
    if (resp && resp.success) {
      setMeetingState(initialMeetingState)
      tableRef.current.reload()
      // onSubmit()
    }
  }
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      params.eventId = eventId
      let { data } = await dispatch(getAllMeetings({
        ...params
      }))
      resolve(data)
    })
  }


  const columns = [
    {
      title: '#',
      key: '_id',
      dataIndex: '_id',
      width: 50,
      render: (ite, record, index) => {
        return (
          <React.Fragment>
            {index + 1}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Person Name',
      key: 'personName',
      dataIndex: 'personName',
      width: 200,
      render: (item) => {
        return (
          <ColumnWidth width={200}>
            {item}
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Contact',
      key: 'contact',
      dataIndex: 'contact',
      width: 150
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      width: 150
    },
    {
      title: 'Meeting Date',
      key: 'date',
      dataIndex: 'date',
      width: 150,
      render: (item) => {
        return (
          <ColumnWidth width={150}>
            {displayDate(item)}
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Designation',
      key: 'designation',
      dataIndex: 'designation',
      width: 200
    },
    {
      title: 'Company Name',
      key: 'companyName',
      dataIndex: 'companyName',
      width: 200,
      render: (item) => {
        return (
          <ColumnWidth width={150}>
            {item}
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Company Website',
      key: 'companyWebsite',
      dataIndex: 'companyWebsite',
      width: 200,
      render: (item) => {
        return (
          <ColumnWidth width={300}>
            {item}
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Details',
      key: 'details',
      dataIndex: 'details',
      width: 200
    }
  ]


  return (
    <Drawer title='Add Meeting' width='60%' onClose={onClose} visible={visible}>
      <div className='card unizportal'>
        <Row gutter={24}>
          <Col span={6}>
            <InputBox title='Person Name *'>
              <Input
                className='form-control'
                size='small'
                value={meetingState.personName}
                onChange={(e) => updateMeetingState({ personName: e.target.value })}
                placeholder="Enter person's name"
              />
            </InputBox>
          </Col>

          <Col span={3}>
            <div style={{ marginTop: 5 }}>
              <CountryCodeWithFlag countryCode={meetingState.countryCode} chooseCode={(val) => {
                updateMeetingState({ countryCode: val })
              }} />
            </div>
          </Col>
          <Col span={7}>
            <InputBox title='Contact *'>
              <Input
                className='form-control'
                size='small'
                value={meetingState.contact}
                onChange={(e) => updateMeetingState({ contact: e.target.value })}
                placeholder='Enter contact number'
              />
            </InputBox>
          </Col>

          <Col span={8}>
            <InputBox title='Email *'>
              <Input
                className='form-control'
                size='small'
                value={meetingState.email}
                onChange={(e) => updateMeetingState({ email: e.target.value })}
                placeholder='Enter email address'
              />
            </InputBox>
          </Col>

          <Col span={6}>
            <InputBox title='Designation *'>
              <Input
                className='form-control'
                size='small'
                value={meetingState.designation}
                onChange={(e) => updateMeetingState({ designation: e.target.value })}
                placeholder='Enter designation'
              />
            </InputBox>
          </Col>

          <Col span={6}>
            <InputBox title='Company Name (If Any)'>
              <Input
                className='form-control'
                size='small'
                value={meetingState.companyName}
                onChange={(e) => updateMeetingState({ companyName: e.target.value })}
                placeholder='Enter company name'
              />
            </InputBox>
          </Col>

          <Col span={6}>
            <InputBox title='Company Website *'>
              <Input
                className='form-control'
                size='small'
                value={meetingState.companyWebsite}
                onChange={(e) => updateMeetingState({ companyWebsite: e.target.value })}
                placeholder='Enter website'
              />
            </InputBox>
          </Col>

          <Col span={6}>
            <InputBox title='Meeting Date & Time *'>
              <DatePicker
                style={{ height: '52px' }}
                className='form-control'
                showTime
                value={meetingState.date ? moment(meetingState.date) : null}
                onChange={(value) => updateMeetingState({ date: value })}
              />
            </InputBox>
          </Col>

          <Col span={24}>
            <InputBox title='Details'>
              <TextArea
                className='form-control'
                rows={3}
                value={meetingState.details}
                onChange={(e) => updateMeetingState({ details: e.target.value })}
                placeholder='Enter meeting details'
              />
            </InputBox>
          </Col>

          <Col span={24}>
            <div style={{ marginTop: 24 }}>
              <a className='btn btn-success' onClick={handleSubmit}>
                Submit
              </a>
              <a className='btn btn-danger ml10' onClick={onClose}>
                Cancel
              </a>
            </div>
          </Col>
        </Row>
      </div>

      <div className='card-body table-responsive mt-3'>
        <TableComp
          columns={columns}
          ref={tableRef}
          pagination={DefaultTablePagination()}
          apiRequest={apiRequest}
          extraProps={{ scroll: { x: 1000 } }}
        />
      </div>
    </Drawer>
  )
}

export default AddMeetingXTravelDrawer
